<template>
  <header class="header-fixed">
    <div class="md-offset">
      <div class="header-wrapp">
        <Navigation />
        <a href="/" class="logo">
          <img src="/img/logo.png" alt="Discoveria" />
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import Navigation from './Navigation'
export default {
  name: 'Header',
  components: {
    Navigation,
  },
}
</script>

<style scoped lang="scss">
.header-fixed {
  background-color: #eee;
  position: fixed;
  z-index: 10;
  width: 100%;
}
.header-wrapp {
  width: 100%;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 576px) {
    padding: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.14);
  }
}
.logo {
  max-width: 150px;
  margin-left: 15px;
  @media screen and (max-width: 991px) {
    max-width: 100px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}
</style>
